import React from 'react';

/**
 * Top-level Error Boundary so a single runtime error (e.g. `.map is not a function`)
 * does NOT result in a fully white page. Renders a friendly fallback instead.
 */
export default class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, info) {
        // eslint-disable-next-line no-console
        console.error('[ErrorBoundary] Caught render error:', error, info);
    }

    handleReload = () => {
        try { window.location.reload(); } catch (_) { /* ignore */ }
    };

    render() {
        if (this.state.hasError) {
            return (
                <div style={{
                    minHeight: '100vh',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    background: '#1B4332',
                    color: '#fff',
                    padding: '24px',
                    fontFamily: 'system-ui, sans-serif',
                }}>
                    <div style={{ maxWidth: 480, textAlign: 'center' }}>
                        <h1 style={{ fontSize: 22, fontWeight: 700, marginBottom: 10 }}>Something went wrong</h1>
                        <p style={{ opacity: 0.85, fontSize: 14, lineHeight: 1.5, marginBottom: 18 }}>
                            We hit a temporary glitch loading this page. Please refresh — if the
                            problem keeps happening, our team has already been notified.
                        </p>
                        <button
                            onClick={this.handleReload}
                            style={{
                                background: '#E07B39',
                                color: '#fff',
                                border: 'none',
                                padding: '10px 22px',
                                borderRadius: 9999,
                                fontWeight: 700,
                                cursor: 'pointer',
                            }}
                        >
                            Reload page
                        </button>
                    </div>
                </div>
            );
        }
        return this.props.children;
    }
}
